function parts(part, schema, paths) {
	if (typeof schema !== 'object') {
		return paths;
	} else if (schema.items) {
		// Push the current part, before recursively adding the rest.
		paths.push(part);
		parts(`${part}[0]`, schema.items, paths);
		parts(`${part}[1]`, schema.items, paths);
		parts(`${part}[*]`, schema.items, paths);
	} else if (schema.properties) {
		// Push the current part, before recursively adding the rest.
		paths.push(part);
		for (const name in schema.properties) {
			const prop = schema.properties[name];
			parts(`${part}.${name}`, prop, paths);
		}
	} else {
		paths.push(part);
	}
	return paths;
}

/**
 * Generate a simple set of example JSON paths given a JSON schema.
 * Does not do any hard stuff - i.e. dereferencing, axway-schema lookup,
 * anyOf, oneOf, etc.
 * @param {object} schema - A JSON schema
 * @param {object} [paths] - An optional array of paths
 * @param {string} [name] - An optional name for the schema
 * @return {string []} An array of example JSON paths
 */
export function jsonSchemaToJSONPath(schema, paths = [], name = null) {
	if (!schema) {
		return paths;
	}
	let part = (name) ? `$.${name}` : '$';
	parts(part, schema, paths);
	return paths;
}
